<div class="quiz-take container-xxl py-6 py-lg-10">

  @if (isLoading()) {
    <div class="card"><div class="card-body is-empty"><span class="spinner-border text-primary"></span></div></div>
  } @else if (attempt(); as a) {

    <!-- The chrome: what paper am I sitting, and how far in am I. It stays put
         between the question and the review screen, so the last "next" does not
         look like it navigated somewhere else. -->
    <header class="quiz-chrome">
      <div class="quiz-chrome__row">
        <div>
          <span class="quiz-chrome__eyebrow">{{ "QUIZ.TITLE" | translate }}</span>
          <h1 class="quiz-chrome__title">{{ a.quiz_title }}</h1>
        </div>
        @if (!reviewing()) {
          <span class="quiz-chrome__count" data-testid="question-index">
            <span class="quiz-chrome__now">{{ index() + 1 }}</span>
            <span class="quiz-chrome__of">/ {{ total() }}</span>
          </span>
        }
      </div>

      <!-- The answer sheet, always on screen.
           This was a rail of unlabelled 8px segments: it showed how many were
           left but you could not aim at one, because "go to question 7" meant
           counting bars. The 2021 exam screen solved the same problem with a
           row of numbered chips carrying per-question state, and it is plainly
           better — the number is the target and the fill is the state, in one
           object. Ported in this palette (sky for answered, filled brand for
           where you are) rather than that build's magenta, and without its
           section tabs and pagination arrows: our papers are drawn from a bank,
           are one section, and are short enough to show whole. -->
      <ol class="quiz-sheetnav" [attr.aria-label]="'QUIZ.REVIEW' | translate">
        @for (question of questions(); track question.id; let i = $index) {
          <li>
            <button type="button" class="quiz-sheetnav__chip"
                    [class.is-done]="!!answers()[question.id]"
                    [class.is-current]="!reviewing() && i === index()"
                    [attr.aria-label]="('QUIZ.QUESTION' | translate) + ' ' + (i + 1)"
                    [attr.aria-current]="!reviewing() && i === index() ? 'step' : null"
                    (click)="goTo(i)">{{ i + 1 }}</button>
          </li>
        }
      </ol>
    </header>

    @if (reviewing()) {
      <section class="quiz-sheet">
        <h2 class="quiz-sheet__head" data-testid="review-heading">{{ "QUIZ.REVIEW" | translate }}</h2>

        @if (unanswered() > 0) {
          <p class="quiz-note is-warn" data-testid="unanswered-notice">
            {{ "QUIZ.UNANSWERED" | translate }} {{ unanswered() }} {{ "QUIZ.ITEMS" | translate }}
          </p>
        } @else {
          <p class="quiz-note is-ok" data-testid="all-answered-notice">
            {{ "QUIZ.ALL_ANSWERED" | translate }}
          </p>
        }

        <!-- A grid rather than a list: with 20+ questions the point is to spot
             the gaps at a glance and jump straight to one. -->
        <div class="quiz-grid">
          @for (question of questions(); track question.id; let i = $index) {
            <button type="button" class="quiz-grid__cell"
                    [class.is-done]="!!answers()[question.id]"
                    (click)="goTo(i)">{{ i + 1 }}</button>
          }
        </div>

        <div class="quiz-actions">
          <button class="btn btn-light order-2 order-sm-1" type="button" (click)="back()">
            {{ "QUIZ.BACK" | translate }}
          </button>
          <button class="btn btn-primary order-1 order-sm-2" type="button"
                  [disabled]="isSubmitting()" data-testid="submit-answers" (click)="submit()">
            {{ isSubmitting() ? ("QUIZ.SUBMITTING" | translate) : ("QUIZ.SUBMIT" | translate) }}
          </button>
        </div>
      </section>
    } @else if (current(); as question) {
      <article class="quiz-sheet">
        <div class="quiz-sheet__meta">
          <span class="quiz-sheet__no">{{ "QUIZ.QUESTION" | translate }} {{ index() + 1 }}</span>
          @if (question.sub_lesson_name) {
            <span class="quiz-chip">{{ question.sub_lesson_name }}</span>
          }
        </div>

        <p class="quiz-sheet__body" data-testid="question-body">{{ question.body }}</p>

        @if (question.question_type === 'choice') {
          <div class="quiz-choices">
            @for (choice of question.choices; track choice.key) {
              <!-- `btn-light-primary` is the selected state an E2E case asserts
                   on; the look comes from `.quiz-choice`, which outranks it. -->
              <button type="button" class="quiz-choice" data-testid="choice"
                      [class.btn-light-primary]="isChosen(question.id, choice.key)"
                      [class.is-chosen]="isChosen(question.id, choice.key)"
                      [attr.aria-pressed]="isChosen(question.id, choice.key)"
                      (click)="choose(question.id, choice.key)">
                <span class="quiz-choice__key">{{ choice.key }}</span>
                <span class="quiz-choice__text">{{ choice.text }}</span>
                <span class="quiz-choice__tick" aria-hidden="true"></span>
              </button>
            }
          </div>
        } @else {
          <input class="quiz-answer" type="text"
                 data-testid="short-answer"
                 [placeholder]="'QUIZ.TYPE_ANSWER' | translate"
                 [ngModel]="answers()[question.id] || ''"
                 (ngModelChange)="setText(question.id, $event)" />
        }

        <div class="quiz-actions">
          <button class="btn btn-light" type="button" [disabled]="index() === 0" (click)="back()">
            {{ "QUIZ.BACK" | translate }}
          </button>
          <button class="btn btn-primary" type="button"
                  data-testid="advance" (click)="advance()">
            {{ index() >= total() - 1 ? ("QUIZ.TO_REVIEW" | translate) : ("QUIZ.NEXT" | translate) }}
          </button>
        </div>
      </article>
    }
  }
</div>
